import React, { useCallback, useMemo } from "react";
import styles from "./Style.module.css";
import constants from "../../../../../config/constants";
import DataTables from "../../../../../Datatables/Datatable.table";
import useGiftStoreTable from "./GiftsStoreTable.hook";
import classNames from "classnames";
import capitalizeFirstLetter from "../../../../../hooks/CommonFunction";
import { removeUnderScore } from "../../../../../helper/Helper";
import { Typography } from "@mui/material";
import { Add } from "@mui/icons-material";
import { ArrowPrimaryButton } from "../../../../../components/Buttons/PrimaryButton";
import GiftStoreCreate from "../GiftStoreCreate/GiftStoreCreate";
import { ListActionComponent } from "../../../../../components/CustomListHeader/CustomListHeader";
import useRoles from "../../../../../hooks/RoleHook";
import Constants from "../../../../../config/constants";

const GiftStoreTable = ({ renderGiftList , updateGiftList}) => {
  const { canUpdate, canCreate} = useRoles(Constants.MODULES.GIFT_STORE);
  const {
    handleSortOrderChange,
    handleRowSize,
    handlePageChange,
    isCalling,
    data,
    currentData,
    currentPage,
    isFetching,
    isDialog,
    toggleDialog,
    editData,
  } = useGiftStoreTable({ renderGiftList });

  const renderFirstCell = useCallback((user) => {
    return (
      <div className={styles.firstCellFlex}>
        <div className={classNames(styles.firstCellInfo, "openSans")}>
          <div>{`${capitalizeFirstLetter(user?.name)}`} </div>
        </div>
      </div>
    );
  }, []);

  const renderType = useCallback((type) => {
    if (type === "INTERNAL") {
      return "Internal";
    } else if (type === "EXTERNAL") {
      return "External";
    }
    return type;
  }, []);

  const tableStructure = useMemo(
    () => [
      {
        key: "reward",
        label: "Gift Title",
        sortable: false,
        render: (temp, all) => (
          <div className={styles.titleCont}>{all?.title}</div>
        ),
      },

      {
        key: "type",
        label: "Type",
        sortable: false,
        render: (temp, all) => <div>{renderType(all?.type)}</div>,
      },
      // {
      //   key: "sub_type",
      //   label: "Sub Type",
      //   sortable: false,
      //   render: (temp, all) => <div>{}</div>,
      // },
      {
        key: "point",
        label: "Points Required",
        sortable: false,
        render: (temp, all) => <div>{all?.required_points}</div>,
      },
      ...(canUpdate ? [{
        key: "user_id",
        label: "Action",
        render: (temp, all) => 
          (
          <div className={styles.listActionContainer}>
            <ListActionComponent
              allData={all}
              handleEdit={toggleDialog}
              key={all?.id}
            />
          </div>
        ),
      },] : [])
    ],
    [renderFirstCell, toggleDialog]
  );

  const tableData = useMemo(() => {
    const datatableFunctions = {
      onSortOrderChange: handleSortOrderChange,
      onPageChange: handlePageChange,
      onRowSizeChange: handleRowSize,
    };

    const datatable = {
      ...constants.DATATABLE_PROPERTIES,
      columns: tableStructure,
      data: currentData,
      count: data.length,
      page: currentPage - 1,
      rowsPerPage: 10,
      allRowSelected: false,
      showSelection: false,
    };

    return { datatableFunctions, datatable };
  }, [
    tableStructure,
    handleSortOrderChange,
    handlePageChange,
    handleRowSize,
    currentData,
    currentPage,
    data,
  ]); // allData,

  return (
    <div className={styles.mainContainer}>
      {isDialog && (
        <GiftStoreCreate
          isOpen={isDialog}
          handleToggle={toggleDialog}
          editData={editData}
          updateGiftList={updateGiftList}
        />
      )}

      <div className={styles.row1}>
        <Typography
          variant={"h5"}
          className={styles.productHeading}
          color={"text.primary"}
        >
          {" "}
          Gift Store Details
        </Typography>
        {canCreate &&<ArrowPrimaryButton
          onClick={toggleDialog}
          icon={<Add fontSize="normal" />}
        >
         ASSOCIATE GIFT
        </ArrowPrimaryButton>}
      </div>
      <br />
      <DataTables {...tableData.datatable} {...tableData.datatableFunctions} />
    </div>
  );
};

export default GiftStoreTable;
